"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Modal = require("../../components/Modal");
var _EditBookingClinicianRateForm = _interopRequireDefault(require("./components/EditBookingClinicianRateForm"));
var _Icon = require("../../components/Icon");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var EditBookingClinicianRateModal = function EditBookingClinicianRateModal(_ref) {
  var booking = _ref.booking,
    onCancel = _ref.onCancel,
    onSuccess = _ref.onSuccess;
  if (!booking) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    visible: !!booking.id,
    title: /*#__PURE__*/_react.default.createElement("div", {
      className: "tw-subtitle-sm-medium"
    }, "Edit booking clinician rate"),
    destroyOnClose: true,
    onCancel: onCancel
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    type: "close-24",
    className: "absolute cursor-pointer text-black top-[20px] right-[20px]",
    onClick: onCancel
  }), /*#__PURE__*/_react.default.createElement(_EditBookingClinicianRateForm.default, {
    booking: booking,
    onSuccess: onSuccess
  }));
};
var _default = EditBookingClinicianRateModal;
exports.default = _default;